import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useAuth } from "../../../../hooks";
import { createServer } from "../../../../api";
import { SimulatorPicker } from "./SimulatorPicker";
import "./ServerForm.scss";

export function ServerForm({ onClose, onReload }) {
  const { accessToken } = useAuth();
  const [selectedIds, setSelectedIds] = useState([]); // simulators opcionales

  const formik = useFormik({
    // <--- CAMBIO: Inicializamos visores en 4
    initialValues: { serverKey: "", visores: 4 },
    validationSchema: Yup.object({
      serverKey: Yup.string().trim().required("Requerido"),
      // <--- CAMBIO: Validación para visores
      visores: Yup.number()
        .typeError("Debe ser un número")
        .min(0, "Mínimo 0")
        .required("Requerido"),
    }),
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        const payload = {
          serverKey: values.serverKey.trim(),
          simulatorDB: selectedIds, // array de ids (opcional)
          visores: values.visores, // <--- CAMBIO: Enviamos visores
        };
        await createServer(accessToken, payload);
        onReload();
        onClose();
      } catch (e) {
        console.error(e);
      }
    },
  });

  return (
    <Form className="server-form" onSubmit={formik.handleSubmit}>
      <Form.Group widths="equal">
        <Form.Input
          name="serverKey"
          label="Server Key"
          placeholder="srv-001"
          onChange={formik.handleChange}
          value={formik.values.serverKey}
          error={formik.errors.serverKey}
        />
        {/* <--- CAMBIO: Input para Visores */}
        <Form.Input
          name="visores"
          label="Visores"
          type="number"
          min={0}
          onChange={formik.handleChange}
          value={formik.values.visores}
          error={formik.errors.visores}
        />
      </Form.Group>

      <div className="server-form__picker">
        <h4>Selecciona simuladores (opcional)</h4>
        <SimulatorPicker
          value={selectedIds}
          onChange={setSelectedIds}
          pageSize={8}
        />
      </div>

      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        Crear servidor
      </Form.Button>
    </Form>
  );
}
